const USER_LOGOUT = 'USER_LOGOUT';

export default function userLogout() {
  localStorage.clear();

  return { type: USER_LOGOUT };
}
